import { Controller } from '@hotwired/stimulus'
import * as analytics from '../../libs/analytics'
import NavigationSource from '../../libs/navigation_source'

export default class extends Controller {
  static values = {
    lessonId: Number,
    schoolClassId: Number
  }

  connect() {
    this.navigationSource = new NavigationSource(this.element)
  }

  disconnect() {
    this.navigationSource.stop()
  }

  ready({ detail }) {
    this.capture('present_mode_entered', { total_slides: detail.totalSlides })
  }

  slideChanged({ detail }) {
    this.capture('slide_changed', {
      slide_index: detail.index,
      direction: detail.index >= detail.previousIndex ? 'forward' : 'backward',
      source: this.navigationSource.consume(),
      total_slides: detail.totalSlides
    })
  }

  capture(event, properties) {
    analytics.capture(event, {
      mode: 'present',
      lesson_id: this.lessonIdValue,
      school_class_id: this.schoolClassIdValue,
      ...properties
    })
  }
}
